module.exports = __webpack_public_path__ + "assets/img/icon_4.6c3efa0b.png";